import { upperFirst } from 'lodash'

import { CSendingTypesGenerallyAvailable } from '@sigmasms/commons'

import { components, proxy, services } from '@/utils'

import RowWithMessageTypeIcon from '@/components/misc/RowWithMessageTypeIcon'
import settingsFields from '@/components/services/settings/fields'

export default function(options) {
  return {
    name: options.path.split('.').map(upperFirst).join(''),

    mixins: [ proxy() ],

    render(h) {
      return h(
        settingsFields(options),
        {
          props: {
            value: this.proxy,
            items: [
              {
                component: components.select,
                props: {
                  items: CSendingTypesGenerallyAvailable.map(item => {
                    return {
                      title: this.getTranslate(`${services.sendings}.types.${item}`),
                      value: item,
                      iconSVG: item,
                      iconColor: item
                    }
                  }),
                  required: true,
                  clearable: false
                },
                scopedSlots: {
                  selection: ({ item }) => {
                    return h(
                      RowWithMessageTypeIcon,
                      {
                        props: {
                          title: item.title,
                          value: item.value,
                          as: 'tag',
                          dense: true
                        }
                      }
                    )
                  }
                }
              }
            ]
          },
          on: {
            input: event => {
              this.$emit('input', event)
            }
          }
        }
      )
    }
  }
}
